<template>
  <audio controls>
    <source :src="src" type="audio/mpeg">
  </audio>
</template>

<script>

export default {
  props: [
    'src'
  ]
}

</script>
